import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Toast } from './toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div [ngClass]="getToastClasses()" class="mb-3 animate-in slide-in-from-right-full duration-300 z-[100]">
      <div class="flex items-start gap-3">
        <div class="-mt-0.5" [ngClass]="getIconClasses()">
          <svg class="fill-current" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <!-- Success Icon -->
            <path *ngIf="toast.type === 'success'" fill-rule="evenodd" clip-rule="evenodd" d="M3.70186 12.0001C3.70186 7.41711 7.41711 3.70186 12.0001 3.70186C16.5831 3.70186 20.2984 7.41711 20.2984 12.0001C20.2984 16.5831 16.5831 20.2984 12.0001 20.2984C7.41711 20.2984 3.70186 16.5831 3.70186 12.0001ZM12.0001 1.90186C6.423 1.90186 1.90186 6.423 1.90186 12.0001C1.90186 17.5772 6.423 22.0984 12.0001 22.0984C17.5772 22.0984 22.0984 17.5772 22.0984 12.0001C22.0984 6.423 17.5772 1.90186 12.0001 1.90186ZM15.6197 10.7395C15.9712 10.388 15.9712 9.81819 15.6197 9.46672C15.2683 9.11525 14.6984 9.11525 14.347 9.46672L11.1894 12.6243L9.6533 11.0883C9.30183 10.7368 8.73198 10.7368 8.38051 11.0883C8.02904 11.4397 8.02904 12.0096 8.38051 12.3611L10.553 14.5335C10.7217 14.7023 10.9507 14.7971 11.1894 14.7971C11.428 14.7971 11.657 14.7023 11.8257 14.5335L15.6197 10.7395Z" fill=""/>

            <!-- Error Icon -->
            <path *ngIf="toast.type === 'error'" fill-rule="evenodd" clip-rule="evenodd" d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12ZM16.0303 8.03033C16.3232 7.73744 16.3232 7.26256 16.0303 6.96967C15.7374 6.67678 15.2626 6.67678 14.9697 6.96967L12 9.93934L9.03033 6.96967C8.73744 6.67678 8.26256 6.67678 7.96967 6.96967C7.67678 7.26256 7.67678 7.73744 7.96967 8.03033L10.9393 11L7.96967 13.9697C7.67678 14.2626 7.67678 14.7374 7.96967 15.0303C8.26256 15.3232 8.73744 15.3232 9.03033 15.0303L12 12.0607L14.9697 15.0303C15.2626 15.3232 15.7374 15.3232 16.0303 15.0303C16.3232 14.7374 16.3232 14.2626 16.0303 13.9697L13.0607 11L16.0303 8.03033Z" fill=""/>

            <!-- Warning Icon -->
            <path *ngIf="toast.type === 'warning'" fill-rule="evenodd" clip-rule="evenodd" d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12ZM12 6.25C12.4142 6.25 12.75 6.58579 12.75 7V13C12.75 13.4142 12.4142 13.75 12 13.75C11.5858 13.75 11.25 13.4142 11.25 13V7C11.25 6.58579 11.5858 6.25 12 6.25ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z" fill=""/>

            <!-- Info Icon -->
            <path *ngIf="toast.type === 'info'" fill-rule="evenodd" clip-rule="evenodd" d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12ZM12 8.25C12.4142 8.25 12.75 8.58579 12.75 9V15C12.75 15.4142 12.4142 15.75 12 15.75C11.5858 15.75 11.25 15.4142 11.25 15V9C11.25 8.58579 11.5858 8.25 12 8.25ZM12 6.5C12.5523 6.5 13 6.94772 13 7.5C13 8.05228 12.5523 8.5 12 8.5C11.4477 8.5 11 8.05228 11 7.5C11 6.94772 11.4477 6.5 12 6.5Z" fill=""/>
          </svg>
        </div>

        <div class="flex-1">
          <h4 class="mb-1 text-sm font-semibold text-gray-800 dark:text-white/90">
            {{ toast.title }}
          </h4>

          <p *ngIf="toast.message" class="text-sm text-gray-500 dark:text-gray-400">
            {{ toast.message }}
          </p>
        </div>

        <button
          type="button"
          (click)="onClose()"
          class="ml-2 text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
    </div>
  `
})
export class ToastComponent {
  @Input() toast!: Toast;
  @Output() close = new EventEmitter<string>();

  onClose() {
    this.close.emit(this.toast.id);
  }

  getToastClasses(): string {
    const baseClasses = 'rounded-xl border p-4';

    switch (this.toast.type) {
      case 'success':
        return `${baseClasses} border-success-500 bg-success-50 dark:border-success-500/30 dark:bg-success-500/15`;
      case 'error':
        return `${baseClasses} border-error-500 bg-error-50 dark:border-error-500/30 dark:bg-error-500/15`;
      case 'warning':
        return `${baseClasses} border-warning-500 bg-warning-50 dark:border-warning-500/30 dark:bg-warning-500/15`;
      case 'info':
        return `${baseClasses} border-blue-500 bg-blue-50 dark:border-blue-500/30 dark:bg-blue-500/15`;
      default:
        return `${baseClasses} border-gray-300 bg-gray-50 dark:border-gray-600 dark:bg-gray-800`;
    }
  }

  getIconClasses(): string {
    switch (this.toast.type) {
      case 'success':
        return 'text-success-500';
      case 'error':
        return 'text-error-500';
      case 'warning':
        return 'text-warning-500';
      case 'info':
        return 'text-blue-500';
      default:
        return 'text-gray-500';
    }
  }
}
